import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from '../../models/base-response.model';
import { OpenCloseTerminalRequest, LastBalanceResponse, TerminalDetail, CashTerminalData, CreateRouteRequest, ValidateRouteRequest, Collector, RouteResponse, CashTerminal } from '../../models/terminals/terminals.model';
import { BaseService } from '../base.service';
import { TerminalStatus } from '../../enums/base.enums';

@Injectable({
  providedIn: 'root'
})

export class TerminalsService extends BaseService<OpenCloseTerminalRequest> {

  constructor(
    private _http: HttpClient,
  ) {
    super(_http, 'lottery/terminals');
  }

  openTerminal(data: OpenCloseTerminalRequest): Observable<ResponseModel<any>> {
    const url = `${this.baseUrl}/:terminalId/open`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post<ResponseModel<any>>(url, data, { headers });
  }

  closeTerminal(data: OpenCloseTerminalRequest): Observable<ResponseModel<any>> {
    const url = `${this.baseUrl}/:terminalId/close`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post<ResponseModel<any>>(url, data, { headers });
  }

  getLastBalances(): Observable<ResponseModel<LastBalanceResponse>> {
    const url = `${this.baseUrl}/:terminalId/last-balances`;

    return this._http.get<ResponseModel<LastBalanceResponse>>(url);
  }

  getCashTerminal(): Observable<ResponseModel<CashTerminal>> {
    const url = `${this.baseUrl}/:terminalId/cash-terminal`;

    return this._http.get<ResponseModel<CashTerminal>>(url);
  }

  getDetails(): Observable<ResponseModel<TerminalDetail>> {
    const url = `${this.baseUrl}/:terminalId/details`;

    return this._http.get<ResponseModel<TerminalDetail>>(url);
  }

  dashboardBalance(filter?: string, itemsPerPage?: number, index?: number): Observable<ResponseModel<CashTerminalData>> {
    // Construir la URL base
    let url = `${this.baseUrl}/:terminalId/balance-dashboard`;

    // Agregar parámetros opcionales a la URL si están definidos
    const params: string[] = [];

    if (filter) {
      params.push(`Filter=${filter}`);
    }
    if (itemsPerPage !== undefined) {
      params.push(`ItemsPerPage=${itemsPerPage}`);
    }
    if (index !== undefined) {
      params.push(`Index=${index}`);
    }

    // Si hay parámetros, agregarlos a la URL
    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    // Realizar la solicitud GET
    return this._http.get<ResponseModel<CashTerminalData>>(url);
  }

  updateRoute(body:CreateRouteRequest): Observable<ResponseModel<RouteResponse>> {
    const url = `${this.baseUrl}/:terminalId/routes`;
    return this._http.put<ResponseModel<RouteResponse>>(url, body);
  }

  getCollector(): Observable<ResponseModel<Collector>> {
    const url = `${this.baseUrl}/:terminalId/routes/collectors `;

    return this._http.get<ResponseModel<Collector>>(url);
  }

  getMissingAmount(): Observable<ResponseModel<{approved:boolean}>> {
    const url = `${this.baseUrl}/:terminalId/shortages `;

    return this._http.get<ResponseModel<{approved:boolean}>>(url);
  }

  deniedRoute(): Observable<ResponseModel<any>> {
    const url = `${this.baseUrl}/:terminalId/routes/denied`;
    return this._http.put<ResponseModel<any>>(url, {});
  }

  collectMoney(): Observable<ResponseModel<any>> {
    const url = `${this.baseUrl}/:terminalId/collect-money`;
    return this._http.post<ResponseModel<any>>(url, null);
  }

  changeStatus(dataStatus: TerminalStatus): Observable<ResponseModel<any>> {
    const url = `${this.baseUrl}/:terminalId/change-status`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.put<ResponseModel<any>>(url, {status:dataStatus}, { headers });
  }
}
